export default __webpack_public_path__ + "static/Lend_green_NL-2f3d9adf33794be236fa94c23f9aee48.png";